import { MagnifyingGlassIcon } from "@heroicons/react/20/solid";
import { type JSX } from "react";

/** * To correctly use this SearchBar component, you have to pass a handler to capture queries onChange and a placeholder ***/
interface SearchBarProps {
  onSearchChange: (value: string) => void;
  placeholder: string;
  defaultValue?: string;
}

export default function SearchBar({
  onSearchChange,
  placeholder,
  defaultValue = "",
}: SearchBarProps): JSX.Element {
  return (
    <div className="relative mt-2 flex items-center">
      <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
        <MagnifyingGlassIcon
          className="h-5 w-5 text-gray-400"
          aria-hidden="true"
        />
      </div>
      <input
        id="search"
        type="search"
        title="Search Pipelines"
        autoComplete="off"
        placeholder={placeholder}
        className="block w-full rounded-md border-0 py-1.5 pl-10 text-gray-900 ring-1 ring-inset ring-gray-300 duration-300 ease-in-out placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
        defaultValue={defaultValue}
        onChange={e => {
          onSearchChange(e.target.value);
        }}
      />
    </div>
  );
}
